import React, { Component } from 'react';

import { scroller } from 'react-scroll';  

const noPadding = {
  paddingLeft: '0px'
}

export default class Navbar extends Component {


  componentDidMount(){
    const navbar = document.getElementById("refNavbar");
    const imageHeight = document.getElementById("homeImage").clientHeight;
    const imageNavBar = document.getElementById("layout-logo-landing");
    window.addEventListener('scroll', () => {
       const hasImage = navbar.classList.contains("show-image");
       if ( navbar.offsetTop > imageHeight && !hasImage) {
        imageNavBar.classList.add("show-image");
        imageNavBar.classList.remove("hide-image");
       }
       else {
        imageNavBar.classList.remove("show-image");
        imageNavBar.classList.add("hide-image");
       }
    });
  }

  componentWillUnmount(){
    window.removeEventListener('scroll',this);
  }
   
  scrollTo(value) {
    scroller.scrollTo(value, {
      duration: 800,
      delay: 0,
      offset: -130,
      smooth: true
    })
  }


  render() {
    return (
      
        <div className="shadow-nav-bar" id="refNavbar">
          <div className="navbar-landing-page">
              <img className="hide-image" id="layout-logo-landing" src="/images/logo-marca.png" alt=""/>
              <ul>
                <li><p style={noPadding} onClick={() => this.scrollTo('aldeiaElement')}>A aldeia</p></li>
                <li><p onClick={() => this.scrollTo('essenciaElement')}>Essência</p></li>
                <li><p onClick={() => this.scrollTo('aquiPertoElement')}>Aqui perto</p></li>
                <li><p onClick={() => this.scrollTo('eventosElement')}>Eventos</p></li>
                <li><p onClick={() => this.scrollTo('noticiasElement')}>Notícias</p></li>
                <li><p onClick={() => this.scrollTo('alojamentoElement')}>Alojamento</p></li>
                <li><p onClick={() => this.scrollTo('restaurantesElement')}>Restaurantes</p></li>
                <li><p onClick={() => this.scrollTo('lojasElement')}>Lojas</p></li>
                <li><p onClick={() => this.scrollTo('comunidadeElement')}>Comunidade</p></li>
                <li><p onClick={() => this.scrollTo('contactosElement')}>Contactos</p></li>
              </ul>
            
          </div>
        </div>

      
    )
  }
}
 